import { StepClass } from '../userTest/types';
export function isOfType(item, type) {
    return item.className === StepClass[type];
}
